import { ReactNode, useMemo } from "react";
import { EmptyPlaceHolder } from "userful-chronos-common-ui/dist/widgets";
import { ITable } from "userful-chronos-app-common-js/dist/models/table/userfulTableInterface";

import "./SmallTable.scss";

interface IProps {
    table: ITable;
    emptyHeaderName?: string;
    emptyHeaderDescription?: string;
    emptyImagePath?: string;
}

export default function SmallTable({ table, emptyHeaderName, emptyHeaderDescription, emptyImagePath }: IProps) {
    const visibleHeaders = useMemo(() => table.headers.filter((h) => !h.hidden), [table.headers]);

    const renderCell = (headerId: string, rowColumns: ITable["rows"][number]["columns"]): ReactNode => {
        const column = rowColumns.find((c) => c.id === headerId);
        return column ? column.component : null;
    };

    return (
        <div className="userful-small-table noselect">
            <div className="userful-small-header-row">
                {visibleHeaders.map((header) => (
                    <div
                        key={header.id}
                        className="userful-small-header"
                        style={{ width: header.width, minWidth: header.minWidth }}
                    >
                        {header.component}
                    </div>
                ))}
            </div>

            {table.rows.length > 0 ? (
                table.rows.map((row) => (
                    <div key={row.id} className="userful-small-row">
                        {visibleHeaders.map((header) => (
                            <div
                                key={header.id}
                                className="userful-small-cell"
                                style={{ width: header.width, minWidth: header.minWidth }}
                            >
                                {renderCell(header.id, row.columns)}
                            </div>
                        ))}
                    </div>
                ))
            ) : (
                <div className="userful-small-wrapper">
                    <EmptyPlaceHolder
                        headerName={emptyHeaderName ?? "No data available"}
                        headerDescription={emptyHeaderDescription ?? "There is no content to display."}
                        hideButton
                        imgPath={emptyImagePath ?? "./notFound.png"}
                    />
                </div>
            )}
        </div>
    );
}
